import type { Quote } from '~/config/quotes'

// Verbatim from the published case studies, attributed by role. Logos are the mono wordmarks the page uses elsewhere.
export const QUOTES: Quote[] = [
  {
    title: 'Brevo',
    logo: '/images/pages/developers/logo-brevo.svg',
    quote:
      'It would have taken several teams months of engineering time to build less than 10 percent of what we’ve built in Omni.',
    cite: 'Lead Analytics Engineer, Brevo',
    cta: 'https://omni.co/blog/case-study-brevo',
  },
  {
    title: 'Handshake',
    logo: '/images/pages/developers/logo-handshake.svg',
    quote:
      'Omni is way more modern and the features are way better for my team and our stakeholders to work with. The AI agent has already become so helpful. We have no regrets about migrating.',
    cite: 'Senior Analytics Engineer, Handshake',
    cta: 'https://omni.co/blog/case-study-handshake',
  },
  {
    title: 'BambooHR',
    logo: '/images/pages/developers/logo-bamboohr.svg',
    quote:
      'Omni helped us transform our in-app analytics into a differentiated, customized experience — without requiring our engineering team to go build a BI product ourselves.',
    cite: 'Senior Product Manager, Data & AI, BambooHR',
    cta: 'https://omni.co/blog/case-study-bamboohr',
  },
  {
    title: 'me&u',
    logo: '/images/pages/developers/logo-meandu.svg',
    quote:
      'I could see the power of Omni. It was clean. The Topic-based modeling made a lot of sense, and having modeling as code through YAML was a big deciding factor for me.',
    cite: 'Director of Data & Analytics, me&u',
    cta: 'https://omni.co/blog/case-study-meandu',
  },
]
